import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { get } from '../../services/api';
import { usePageLoader } from '../../contexts/PageLoaderContext';
import { useNotifier } from '../../contexts/NotificationContext';

import Title from '../../components/common/Title/Title';
import FormBuilder from '../../components/FormBuilder/FormBuilder';
import {showBackButton} from "../../services/telegramService"; // Наш основной компонент

const EditFormPage = () => {
    const { formId } = useParams();
    const navigate = useNavigate();
    const intl = useIntl();
    const { showPageLoader, hidePageLoader } = usePageLoader();
    const { addNotification } = useNotifier();

    const [formToEdit, setFormToEdit] = useState(null);

    useEffect(() => {
        showBackButton();
    }, []);

    useEffect(() => {
        showPageLoader();
        get(`forms/${formId}`)
            .then(response => {
                if (response.data) {
                    setFormToEdit(response.data);
                } else {
                    throw new Error('Form not found.');
                }
            })
            .catch(error => {
                addNotification(
                    error.message || intl.formatMessage({ id: "formSettingsPage.loadingError" }), // Можно использовать тот же ID ошибки
                    'error'
                );
                navigate('/'); // Если форма не найдена, уходим на главную
            })
            .finally(() => {
                hidePageLoader();
            });
    }, [formId, showPageLoader, hidePageLoader, addNotification, navigate, intl]);

    // Пока данные не загружены, PageLoader активен
    if (!formToEdit) {
        return null;
    }

    return (
        <div>
            <Title>{intl.formatMessage({ id: "editFormPage.title" })}</Title>
            <FormBuilder initialForm={formToEdit} />
        </div>
    );
};

export default EditFormPage;
